<!--
* @description  参数1
* @fileName  addUser
* @author userName
* @date 2024-01-03 10:11:39
!-->
<template>
  <div id="addUser" class="addUser">
    <Dialog :value="value" @close="closeDialog()">
      <template v-slot:title>
        <div v-if="!id">Add User</div>
        <div v-if="id">Edit User</div>
      </template>
      <template v-slot:body>
        <div class="main-info p24 check-price-form">
          <el-form
            ref="formData"
            :model="formData"
            :rules="allRules"
            label-position="top"
            size="medium"
            class="item-Surcharge"
            @submit.native.prevent
          >
            <el-form-item class="flex-width_1" prop="realName" label="Name">
              <el-input v-model="formData.realName" />
            </el-form-item>
            <el-form-item class="flex-width_1" prop="email" label="Email">
              <el-input v-model="formData.email" />
            </el-form-item>
            <el-form-item class="flex-width_1" prop="mobilePhone" label="Phone number">
              <el-input v-model="formData.mobilePhone" />
            </el-form-item>
            <el-form-item class="flex-width_1" prop="customerRole" label="Role">
              <el-select v-model="formData.customerRole" style="text-align: left;width: 100%;" placeholder="">
                <el-option
                  v-for="item in roleList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <div class="foot-class">
          <button class="cancel" @click="closeDialog">Cancel</button>
          <button class="save by-button--primary" :loading="btnLoading" @click="clickSave">OK</button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import {
  GetUser,
  CreateUser,
  UpdateUser
} from '../../../api/user.js'
import Dialog from '../../../components/Dialog/Dialog.vue'
export default {
  name: 'AddUser',
  components: {
    // 组件的引用
    Dialog
  },
  props: {
    // 父辈向子辈传参
    value: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      id: '',
      btnLoading: false,
      formData: {
        id: '',
        realName: '',
        email: '',
        mobilePhone: '',
        customerRole: 2
      },
      roleList: [{
        label: 'Admin',
        value: 1
      },
      {
        label: 'User',
        value: 2
      }
      ],
      allRules: {
        realName: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }],
        email: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }],
        customerRole: [{
          required: true,
          trigger: 'blur'
        }]
      }
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  mounted() {
    // 页面进入时加载内容
  },
  created() {
    // 实例被创建之后执行代码
  },
  methods: {
    // 方法
    closeDialog() {
      this.$emit('close', false)
    },
    init(id) {
      this.id = id || ''
      this.formData.id = id || ''
      this.$nextTick(() => {
        this.$refs['formData'].resetFields()
        if (this.formData.id) {
          GetUser(this.formData.id).then(res => {
            this.formData = res.data
          })
        }
      })
    },
    clickSave() {
      // 表单校验
      this.$refs['formData'].validate((val) => {
        if (val) {
          this.btnLoading = true
          if (!this.formData.id) {
            CreateUser(this.formData).then((res) => {
              this.$message({
                message: 'Operate success',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.btnLoading = false
                  this.closeDialog()
                  this.$emit('refresh', true)
                }
              })
            }).finally(() => {
              this.btnLoading = false
            })
          } else {
            UpdateUser(this.formData).then((res) => {
              this.$message({
                message: 'Operate success',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.btnLoading = false
                  this.closeDialog()
                  this.$emit('refresh', true)
                }
              })
            }).finally(() => {
              this.btnLoading = false
            })
          }
        }
      })
    }

  }
}
</script>
<style scoped lang='scss'>
	::v-deep .dialog__header {
		text-align: left;
	}

	::v-deep .dialog__body {
		padding: 0;

		.el-form-item {
			margin-bottom: 0;

			.el-form-item__label {
				float: left;
			}
		}
	}

	.foot-class {
		margin: 24px 0;
		padding-bottom: 24px;
		text-align: right;

		.cancel {
			width: 72px;
			height: 32px;
			background: #FFFFFF;
			border-radius: 4px;
			border: 1px solid #DDDDDD;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #333333;
			margin-right: 16px;
			cursor: pointer;
		}

		.save {
			width: 72px;
			height: 32px;
			border-radius: 4px;
			cursor: pointer;
		}
	}
</style>
